import React, { useEffect } from 'react';

import { TScreens } from '@/containers/Modal';
import { SmButton } from '@smiles/smiles-react-design-system';

import useApi from '@/hooks/useApi';
import useEvent from '@/hooks/useEvent';
import usePurchase from '@/hooks/usePurchaseData';

import { TModalContent } from '@/services/requests/Liferay/types';
import { dispatchInteraction } from '@/services/requests/Interactions/helpers';

import { clearHtmlTags } from '@/helpers/HtmlHelper/clearHtmlTags';

type TProps = {
  liferayContent: TModalContent;
  changeScreen: (newScreen: TScreens) => void;
  onClose: () => void;
};

export const ScreenSelectVoucherAerea = ({
  liferayContent,
  changeScreen,
  onClose,
}: TProps) => {
  const { title, description, milesPurchaseVoucher, airlineVoucher } =
    liferayContent;

  const { currentVoucher } = usePurchase();

  useEffect(() => {
    if (!currentVoucher) {
      changeScreen('error');
    }
  }, [currentVoucher, changeScreen]);
 
  const { ApiInteractions } = useApi();
  const event = useEvent();
  const baseUrl = window.location.origin;
 
  const handleClickBtnMilesPurchaseVoucher = () => {

    const redirectUrlPurchaseMiles = `${baseUrl}${clearHtmlTags(liferayContent.milesPurchaseVoucherLink ? liferayContent.milesPurchaseVoucherLink.text : '' ) }`;
  


    dispatchInteraction(
      ApiInteractions,
      'extra_vs_voucher_select_click_miles_purchase',
      {
        recommendationId: event.data.recommendationId,
      },
    );

   
    window.location.href = redirectUrlPurchaseMiles;

  };

  const handleClickBtnAirlineVoucher = (): void => {
    
    const redirectUrlVoucherLink = `${baseUrl}${clearHtmlTags(liferayContent.airlineVoucherLink ? liferayContent.airlineVoucherLink.text : '') }`;
    dispatchInteraction(
      ApiInteractions,
      'extra_vs_voucher_select_click_airline',
      {
        recommendationId: event.data.recommendationId,
      },
    );


    window.location.href = redirectUrlVoucherLink;
  };

  const handleClose = (): void => {
    dispatchInteraction(
      ApiInteractions,
      'extra_vs_voucher_select_click_close',
      {
        recommendationId: event.data.recommendationId,
      },
    );

    onClose();
  };

  return (
    <div
      className="smls-b2c-modals__modal"
      data-testid="screen-select-voucher-aerea"
    >
      <div className="smls-b2c-modals__button--close">
        <SmButton
          onClick={handleClose}
          isPill
          isOutlined
          icon={<span className="material-icons">close</span>}
        />
      </div>

      <div className="smls-b2c-modals__modal--select-voucher">
        {title?.text && (
          <h2
            className="smls-b2c-modals__modal--select-voucher__title" // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: title.text }}
          />
        )}
        {description?.text && (
          <p
            className="smls-b2c-modals__modal--select-voucher__description" // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: description.text }}
          />
        )}
        <div className="smls-b2c-modals__modal--select-voucher__buttons">
          {milesPurchaseVoucher?.text && (
            <SmButton
              className="smls-b2c-modals__modal--select-voucher__buttons--voucher"
              loadingSize="large"
              text={clearHtmlTags(milesPurchaseVoucher.text)}
              variant="primary"
              isPill
              onClick={() => handleClickBtnMilesPurchaseVoucher()}
            />
          )}
          {airlineVoucher?.text && (
            <SmButton
              className="smls-b2c-modals__modal--select-voucher__buttons--voucher"
              loadingSize="large"
              text={clearHtmlTags(airlineVoucher.text)}
              variant="primary"
              isPill
              onClick={() => handleClickBtnAirlineVoucher()}
            />
          )}
        </div>
      </div>
    </div>
  );
};
